import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 26px;
  color: #000000;
  text-align: center;
`;
